<mat-spinner [diameter]="diameter"
             [strokeWidth]="strokeWidth"></mat-spinner>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/spinner/spinner.component.html